/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForAws extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForAws.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForAws>): BillingInformationForAws {
        let obj = Object.assign(new BillingInformationForAws(), model);
        BillingInformationForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForAws>): BillingInformationForAws {
        if (!model) return null;
        return BillingInformationForAws.newInstance(<BillingInformationForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForAws) {
        if (!obj) return;

        models.BillingInformationForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForAws): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
